module.exports = __webpack_public_path__ + "static/media/coupon04_zhChs.4966637e.png";